export default "__VITE_ASSET__CfevE6rr__"